export default __webpack_public_path__ + "static/media/938.e4115fb2.gif";